//webアプリのバージョン番号、数字型のため長さは固定で
window.appVersion = "20260827001";
//APIの接続先は .env.production / .env.staging で切り替え（build=本番、build:staging=ステージング）
window.API_URL = process.env.VUE_APP_API_URL;
//checkalways取得時に追加で取得する情報がある場合はページ初期化時に格納しておく
//window.gaID = "UA-42386303-1";
window.checkalways_includes = "";

//------------------------------------------------------------
//フロントエラー収集：発生したJSエラーをサーバー(app/html/api/front/errordebug.php)経由で
//mmcms標準のログ(var/log/client_error_log.log)へ送信する。
//window.onerror・unhandledrejection・リソース読み込み失敗・Vueのエラーハンドラの4経路で捕捉し、
//取りこぼしを防ぐ。Vueインスタンス生成より前に登録し、初期化中のエラーも拾えるようにする。
//------------------------------------------------------------
(function() {
    var sentRecently = {};
    function reportClientError(type, message, stack) {
        try {
            var key = type + ':' + String(message).slice(0, 200);
            var now = Date.now();
            //同一内容の連続送信のみ3秒間抑制する（初回は必ず送信する）
            if (sentRecently[key] && now - sentRecently[key] < 3000) return;
            sentRecently[key] = now;

            var route = '';
            try { route = window.location.pathname + window.location.search; } catch (e) {}

            fetch(window.API_URL + 'errordebug', {
                method: 'POST',
                cache: 'no-cache',
                headers: { 'Content-Type': 'application/json' },
                keepalive: true,
                body: JSON.stringify({
                    type: type,
                    errormsg: String(message).slice(0, 2000),
                    stack: stack ? String(stack).slice(0, 4000) : '',
                    route: route,
                    version: window.appVersion,
                }),
            }).catch(function() {});
        } catch (e) {
            //送信処理自体の失敗はここで握りつぶす（無限ループ防止）
        }
    }

    window.onerror = function(message, source, lineno, colno, error) {
        reportClientError('onerror', message, error && error.stack ? error.stack : (source + ':' + lineno + ':' + colno));
    };
    window.addEventListener('unhandledrejection', function(event) {
        var reason = event.reason;
        reportClientError('unhandledrejection', reason && reason.message ? reason.message : String(reason), reason && reason.stack ? reason.stack : '');
    });
    //スクリプト・リソースの読み込み失敗（chunk読み込み失敗等）はイベントがバブリングしないためキャプチャフェーズで捕捉する
    window.addEventListener('error', function(event) {
        var t = event.target;
        if (t && (t.tagName === 'SCRIPT' || t.tagName === 'LINK' || t.tagName === 'IMG')) {
            reportClientError('resource', t.tagName + ' load failed: ' + (t.src || t.href), '');
        }
    }, true);

    window.__reportClientError = reportClientError;
})();

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import helper from './helpers/helper'
import record from './helpers/record'
import "es6-promise/auto";
import "fetch-polyfill";




import './assets/css/reset.css';
import './assets/css/app.scss';

Vue.config.productionTip = false
//Vueのレンダリング・ライフサイクル・ウォッチャー内で発生した例外はwindow.onerrorでは拾えないため、専用のハンドラで補足する
Vue.config.errorHandler = function(err, vm, info) {
    window.__reportClientError('vue', err && err.message ? err.message : String(err), (err && err.stack ? err.stack : '') + ' / info: ' + info);
    console.error(err, info);
};
Vue.mixin(helper)
Vue.mixin(record)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')